module.exports = __webpack_public_path__ + "img/icon_group@2x.2673e777.png";